import { isUndefined } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

import {
  AdditionalStructureKey,
  selectAdditionalStructureCommentaryTableDisplayDictionary,
} from '../../../redux/features/selectors/commentarySelectors/selectAdditionalStructureCommentary.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { CommentarySubSection } from '../components/CommentarySubsection.tsx';
import { CommentaryTable } from '../components/CommentaryTable.tsx';
import { structuresCommentarySubSectionProps } from './consts.ts';

export const AdditionalStructure = ({
  structureKey,
  standalone,
}: {
  structureKey: AdditionalStructureKey;
  standalone?: boolean;
}) => {
  const structures = useAppSelector(selectAdditionalStructureCommentaryTableDisplayDictionary);
  const structure = structures[structureKey];

  if (isUndefined(structure)) return null;

  const structureComponent = (
    <Flex flexDirection="column" key={structure.label} gap={2}>
      <Typography variant="h3">{structure.label}</Typography>
      <CommentaryTable data={structure.tableData} helperText={structure.helperText} />
    </Flex>
  );

  return standalone ? (
    <CommentarySubSection {...structuresCommentarySubSectionProps}>
      {structureComponent}
    </CommentarySubSection>
  ) : (
    structureComponent
  );
};
